import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, convertStylesStringToObject, createFilePath, GotoMall, isSafari } from '../../utils/obj-utils';
import temp from '../../temp/config';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper';
import 'swiper/swiper.min.css';
import './style.scss';

export default function Banner(props) {
  const { fields } = props;
  const swiperRef = useRef(null);
  const isMobile = isMobileFun();
  const id = props?.params ? props?.params?.pagename : '';
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [indexready, setIndexready] = useState(0);
  const [isShow, setIsShow] = useState(0);
  const [isclickNextPrev, setIsclickNextPrev] = useState(false);
  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    if (props.eventRef) {
      return {
        sendEvent
      };
    }
  });
  const sendEvent = () => {
    if (id) {
      window.Dmp.sectionAction(id);
      window.navigationIndex = props.fields.navigationIndex.value;
      window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
      if (document.querySelector('.FooterFixmeau_v1')) {
        if (window.navigationPagename !== 'home' && window.navigationPagename !== 'choose' && window.navigationPagename !== 'order') {
          document.querySelector('.FooterFixmeau_v1').style.display = 'flex';
        } else {
          document.querySelector('.FooterFixmeau_v1').style.display = 'none';
        }
      }
    }
  };

  const AppSchemeUrlRefClick = (e, item) => {
    if (e.target && e.target.dataset && e.target.dataset.appschemeurl) {
      GotoMall(e.target.dataset.appschemeurl, e.target.dataset.htmlItem1, isMobile);
    } else if (e.target && e.target.dataset && e.target.dataset.include) {
      let include = item?.fields?.include?.value ? JSON.parse(item?.fields?.include?.value) : '';
      if (include && include?.userAgent == 'isSafari' && isSafari()) {
        window.open(include?.[temp.app.term]);
        window.Dmp.clickAction(e.target.dataset.htmlItem1, include?.[temp.app.term]);
      } else {
        try {
          window.top.location.href = e.target.dataset.include;
        } catch (e) {
          location.href = e.target.dataset.include;
        }
        if (e.target.dataset.htmlItem1) {
          window.Dmp.clickAction(e.target.dataset.htmlItem1, e.target.dataset.include);
        }
      }
    }
  };
  const swiperslideTo = (index) => {
    swiperRef.current.swiper.slideTo(index);
  };
  useEffect(() => {
    if (window.location.href.indexOf('vehicles/show/') !== -1 || window.location.href.indexOf('-show') !== -1) {
      setIsShow(1);
    }
  }, []);
  return (
    <div className={`Home_v1 ${isShow === 1 ? 'showUse' : ''}`} id={id}>
      <div className="hash"></div>
      <Swiper
        ref={swiperRef}
        slidesPerView={1}
        className="swiper"
        spaceBetween={0}
        initialSlide={0}
        observer={true}
        resizeObserver={true}
        updateOnWindowResize={true}
        modules={[EffectFade, Pagination, Navigation, Autoplay]}
        navigation={{
          prevEl: '.Home_v1 .prev',
          nextEl: '.Home_v1 .next',
          disabledClass: 'disabled'
        }}
        effect={'fade'}
        fadeEffect={{ crossFade: true }}
        autoplay={{ delay: 3000, autoPlay: true, disableOnInteraction: false }}
        onInit={(e) => {}}
        onSlideChangeTransitionEnd={(e) => {
          setSwiperIndex(e.activeIndex);
        }}
      >
        {fields?.lists.map((item, index) => {
          return (
            item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value && (
              <SwiperSlide className="item" key={index}>
                {item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value.indexOf('data-appschemeurl') !== -1 ||
                item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value.indexOf('data-include') !== -1 ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value?.replaceHtml() }}
                    onClick={(e) => AppSchemeUrlRefClick(e, item)}
                  />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value?.replaceHtml() }} />
                )}
              </SwiperSlide>
            )
          );
        })}
        {fields[`${getPrefixField('nexticon', isMobile)}`]?.value && (
          <div
            className="next"
            data-html-item={fields?.nextdmp?.value}
            onClick={() => {
              setIsclickNextPrev(true);
            }}
          >
            <img className="icon" src={createFilePath(fields[`${getPrefixField('nexticon', isMobile)}`]?.value)} alt="广汽本田" />
          </div>
        )}
        {fields[`${getPrefixField('nexticon', isMobile)}`]?.value && (
          <div
            className="prev"
            data-html-item={fields?.prevdmp?.value}
            onClick={() => {
              setIsclickNextPrev(true);
            }}
          >
            <img className="icon" src={createFilePath(fields[`${getPrefixField('previcon', isMobile)}`]?.value)} alt="广汽本田" />
          </div>
        )}

        <div className={`swiper-pagination ${fields?.paginationclass?.value}`}>
          {fields?.lists.map((item, index) => {
            let cout = 0;
            fields?.lists.map((item) => {
              if (!item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value) {
                cout++;
              }
            });
            if (cout > 0) {
              index = index - cout;
            }

            return (
              item?.fields[`${getPrefixField('bannerhtml', isMobile)}`]?.value && (
                <span
                  key={index}
                  className={`swiper-pagination-bullet ${swiperIndex === index ? 'swiper-pagination-bullet-active' : ''}`}
                  onClick={() => {
                    swiperslideTo(index);
                    setIsclickNextPrev(true);
                    window.Dmp.clickAction(fields?.paginationdmp?.value ? fields?.paginationdmp?.value + (index + 1) : '');
                  }}
                ></span>
              )
            );
          })}
        </div>
      </Swiper>
    </div>
  );
}
